import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../components/Seo";
import TeamCard from "../components/TeamCard";
import SectionHeader from "../components/SectionHeader";
import TraegervereineGrid from "../components/TraegervereineGrid";
import { fetchTeams } from "../cms/teams";
import { fetchTraegervereine } from "../cms/traegervereine";

export default function Teams() {
  const [teams, setTeams]           = useState([]);
  const [loading, setLoading]       = useState(true);
  const [traegervereine, setTraeger] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTeams()
      .then(setTeams)
      .finally(() => setLoading(false));
    fetchTraegervereine().then(setTraeger);
  }, []);

  return (
    <>
      <Seo
        title="Teams"
        description="Die TSS-Teams: B-Junioren und C-Junioren — Kader, Trainer und Saison-Infos."
        path="/teams"
      />

      {/* Page-Header */}
      <section className="bg-primary text-white">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <p className="text-accent font-bold uppercase tracking-widest text-xs mb-3">Saison 2025/26</p>
          <h1 className="text-5xl md:text-6xl font-extrabold uppercase">Unsere Teams</h1>
          <p className="mt-4 text-white/80 max-w-xl text-lg">
            Zwei Mannschaften. Ein Ziel. Die beste Nachwuchsförderung am Sempachersee.
          </p>
        </div>
      </section>

      {/* Team-Cards */}
      <section className="mx-auto max-w-6xl px-4 py-16">
        {loading ? (
          <div className="grid gap-8 md:grid-cols-2">
            <div className="bg-dark/5 animate-pulse h-96" />
            <div className="bg-dark/5 animate-pulse h-96" />
          </div>
        ) : teams.length === 0 ? (
          <p className="text-dark/60">Noch keine Teams erfasst.</p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2">
            {teams.map((team) => (
              <div key={team.id} id={team.id} className="scroll-mt-24">
                <TeamCard team={team} onClick={() => navigate(`/teams/${team.id}`)} />
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Trägervereine — aus dem CMS, mit optionalem Logo */}
      <section className="bg-light">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <SectionHeader
            eyebrow="Das Fundament"
            title="Trägervereine"
            text="Das TSS ist ein Zusammenschluss von fünf Vereinen rund um den Sempachersee. Gemeinsam stellen wir die Basis für die Nachwuchsförderung in der Region."
          />
          <div className="mt-2">
            <TraegervereineGrid vereine={traegervereine} />
          </div>
        </div>
      </section>

      {/* Talentiert und motiviert */}
      <section className="bg-primary text-white">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <h2 className="text-3xl md:text-4xl font-extrabold uppercase">Talentiert und motiviert?</h2>
          <p className="mt-3 text-white/80 text-lg max-w-xl leading-relaxed">
            Wende dich an die Trainer deines Trägervereins — die Coaches der fünf Vereine rund um den Sempachersee sind die erste Anlaufstelle für talentierte Junioren.
          </p>
        </div>
      </section>
    </>
  );
}
